<div
  class="p-3 tab-pane position-relative h-100"
  id="nav-contact"
  role="tabpanel"
  aria-labelledby="nav-contact-tab"
>
  <iframe
    allow="fullscreen;xr-spatial-tracking"
    class="w-100 h-100"
    [ngClass]="{ 'bg-white': iframeLoaded }"
    [src]="url | safeURL"
    frameborder="0"
    (load)="iframeLoaded = true"
  ></iframe>
</div>
